import './flash_message.scss';

import { bool, func, node, string } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

function FlashMessage({ message, color, hidden, onDismiss }) {
  return (
    <Alert
      isOpen={!hidden}
      toggle={onDismiss}
      color={color}
      className="c-flash-message mb-2"
    >
      {message}
    </Alert>
  );
}

FlashMessage.propTypes = {
  message: node.isRequired,
  onDismiss: func.isRequired,
  color: string.isRequired,
  hidden: bool,
};

FlashMessage.defaultProps = {
  hidden: false,
};

export default FlashMessage;
